var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFolderOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5013 3.125C2.38625 3.125 2.29297 3.21828 2.29297 3.33333V17.5C2.29297 17.8452 2.01315 18.125 1.66797 18.125C1.32279 18.125 1.04297 17.8452 1.04297 17.5V3.33333C1.04297 2.52792 1.69589 1.875 2.5013 1.875H5.86099C6.29379 1.875 6.70424 2.06724 6.98132 2.39973L8.62737 4.375H15.0013C16.267 4.375 17.293 5.40102 17.293 6.66667V9.16667C17.293 9.51184 17.0131 9.79167 16.668 9.79167C16.3228 9.79167 16.043 9.51184 16.043 9.16667V6.66667C16.043 6.09136 15.5766 5.625 15.0013 5.625H5.83464C5.48946 5.625 5.20964 5.34518 5.20964 5C5.20964 4.65482 5.48946 4.375 5.83464 4.375H7.00023L6.02104 3.19997C5.98145 3.15246 5.92281 3.125 5.86099 3.125H2.5013Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37206 9.92395C5.37206 9.92396 5.37206 9.92394 5.37206 9.92395L2.59112 16.8763H14.9753L17.6943 10.0787C17.7491 9.94188 17.6484 9.79297 17.5009 9.79297H5.5655C5.48036 9.79297 5.40371 9.84486 5.37206 9.92395ZM4.21148 9.45966C4.43294 8.90609 4.96915 8.54297 5.5655 8.54297H17.5009C18.5326 8.54297 19.2382 9.58492 18.8549 10.543L15.9788 17.7334C15.8839 17.9707 15.654 18.1263 15.3985 18.1263H1.66797C1.46058 18.1263 1.2667 18.0234 1.15043 17.8517C1.03416 17.68 1.01065 17.4617 1.08767 17.2692L4.21148 9.45966Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolderOpen);
export default __webpack_public_path__ + "static/media/ic-folder-open.467524c075c7984c7c12479db594f55d.svg";
export { ForwardRef as ReactComponent };